import type { RequestPolicy } from 'urql';

import { useGetSweetpassTierQuery } from '@order/graphql';
import { useFeatureFlag } from '@order/LaunchDarkly';
import { useTrackEventEffect } from '@order/Telemetry';

export const useSweetpassTier = (
  requestPolicy: RequestPolicy = 'cache-only',
) => {
  const isSweetpassEnabled = useFeatureFlag('OPS-sweetpass-enabled', {
    listenForChanges: true,
  });

  const [sweetpassTierResponse, refetchSweetpassTier] =
    useGetSweetpassTierQuery({
      requestPolicy,
      pause: !isSweetpassEnabled,
    });

  const isSweetpassTierLoading = sweetpassTierResponse?.fetching;

  const sweetpassTier = sweetpassTierResponse?.data?.loyaltyProfile?.tier;
  const sweetpassTierName = sweetpassTier?.name;

  const sweetpassNextTier =
    sweetpassTierResponse?.data?.loyaltyProfile?.tier?.nextTier;
  const sweetpassNextTierId = sweetpassNextTier?.id;
  const sweetpassNextTierName = sweetpassNextTier?.name;

  const joinDate = sweetpassTierResponse?.data?.loyaltyProfile?.joinDate;

  useTrackEventEffect({
    name: 'sweetpass.tier.changed',
    payload: { loyaltyTier: sweetpassTierName ?? '' },
    skip: !isSweetpassEnabled || isSweetpassTierLoading || !sweetpassTierName,
  });

  return {
    joinDate,
    sweetpassTierName,
    sweetpassNextTierId,
    sweetpassNextTierName,
    isSweetpassEnabled,
    isSweetpassTierLoading,
    refetchSweetpassTier,
  };
};
